// Header.js
import React, { useState, useEffect, useContext } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Nav, NavHeader, NavLeft, NavCenter, NavRight, MenuLink, UserLink, AuthButton, LogoImage } from './Navbar.Style';

import { AuthContext } from '../../reducers/auth_reducers';


function Navbar(props) {
  const { state, dispatch } = useContext(AuthContext);
  const { authenticated, setAuthenticated } = useState(state.isAuthenticated)

  let history = useHistory();

  let isLogged = () => {
    
    let navLogged = ( 
      <NavRight>
        <Link to="/dashboard">
          <UserLink>Hola { localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).firstName : ""}</UserLink>
        </Link>
        <MenuLink onClick={() => {
          dispatch({ type: "LOGOUT" })
          history.push('/');
          }}>
          <AuthButton auth>Logout</AuthButton>
        </MenuLink>
      </NavRight>
    );
    let navNotLogged = (
      <NavRight>
        <Link to="/signup">
          <AuthButton auth>Signup</AuthButton>
        </Link>
        <Link to="login">
          <AuthButton auth>Login</AuthButton>
        </Link>
      </NavRight>
    );
    return(
      localStorage.getItem('token') ? navLogged : navNotLogged 
    );
  };

  useEffect(() => {
    isLogged();
  }, [state.authenticated]);

  return (
    <Nav>
      <NavHeader>
        <NavLeft>
          <Link to="/">
          <LogoImage src="https://res.cloudinary.com/dojodevs/image/upload/v1579499044/smartia/SmartiaNEW-01_etrcdr.png" alt="Smartia Logo"/>
          </Link>
        </NavLeft>
        <NavCenter>
        </NavCenter>
        { isLogged() }
      </NavHeader>
    </Nav>
  );
}
export default Navbar;